import { css, theme } from '../../theme';
import { withPublicAssets, IpublicAssets } from '@utils/url.utils';

const getFonts = ({ publicAssets }: { publicAssets: IpublicAssets }) => css`
    @font-face {
        src: url(${publicAssets('/fonts/OV/VauxhallNeue-Light.otf')}) format('opentype');
        font-family: ${theme.fonts.fontBase};
        font-weight: ${theme.fontWeights.textLight};
        font-style: normal;
    }
    @font-face {
        src: url(${publicAssets('/fonts/OV/VauxhallNeue-Regular.otf')}) format('opentype');
        font-family: ${theme.fonts.fontBase};
        font-weight: ${theme.fontWeights.textRegular};
        font-style: normal;
    }
    @font-face {
        src: url(${publicAssets('/fonts/OV/VauxhallNeue-Bold.otf')}) format('opentype');
        font-family: ${theme.fonts.fontBase};
        font-weight: ${theme.fontWeights.textMedium};
        font-style: normal;
    }
    @font-face {
        src: url(${publicAssets('/fonts/OV/VauxhallNeue-ExtraBold.otf')}) format('opentype');
        font-family: ${theme.fonts.fontBase};
        font-weight: ${theme.fontWeights.textBold};
        font-style: normal;
    }
`;

export default withPublicAssets(getFonts)();
